import { Component, Input, OnInit } from '@angular/core';
import { Worksheet } from '../../../../models/worksheet';
import { WorksheetService } from '../../../../services/worksheet.service';
import { CommunicationService } from '../../../../services/communication.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'sidebar-worksheet-item',
    templateUrl: './worksheet-item.component.html',
    styleUrls: ['./worksheet-item.component.scss'],
    standalone: true,
    imports: [
        FormsModule
    ]
})
export class WorksheetItemComponent implements OnInit {

    @Input() worksheet: Worksheet;

    editMode = false;
    title: string;
    belongsTo: null|string = null;

    constructor(public worksheetService: WorksheetService,
                public communicationService: CommunicationService) {

    }

    ngOnInit() {
        this.setProperties();
    }

    setProperties() {
        this.title = this.worksheet.name;
        this.editMode = false;

        if (this.worksheet.homework !== undefined) {
            this.belongsTo = this.worksheet.homework.title;
        }
    }

    protected toggleEditMode() {
        this.editMode = !this.editMode;
    }

    protected openWorksheet() {
        this.worksheetService.openWorksheet(this.worksheet);
    }

    protected editWorksheet() {
        this.worksheet.name = this.title;

        this.worksheetService.editWorksheet(this.worksheet)
            .then(() => {
                this.communicationService.announceWorksheetChange();
            });
    }

    protected deleteWorksheet() {
        const deleted = this.worksheetService.deleteWorksheet(this.worksheet);

        deleted.then(result => {
            this.communicationService.announceWorksheetChange();

            return result;
        }).catch(error => {
            console.log(error);
        });
    }
}
